import { System } from './../../shared-components/System';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { StudentDigitalContent } from './models/student-digital-content.model';
import { Lookup } from '../../shared-components/lookup/lookup.model';
import { StudentService } from '../../shared-components/student/student.service';

@Injectable()
export class StudentDigitalContentService {

  constructor(private http: HttpClient,
              private studentService: StudentService) { }

    documentTypes: Lookup[] = [];

    getStudentDigitalContent(studentId: number, schoolId: number): Observable<StudentDigitalContent[]> {
        let paramString: string = '';
        paramString += '?studentId=' + studentId;
        paramString += '&schoolId=' + schoolId;

      return this.http.get<StudentDigitalContent[]>(System.apiURL.Student + 'GetStudentDigitalContent' + paramString);
    }

    saveStudentDigitalContent(sdc: StudentDigitalContent, schoolId: number): Observable<number> {
      // let paramString: string = '';
      // paramString += '?schoolId=' + schoolId;

      // return this.http.post<number>(System.apiURL.Student + 'SaveStudentDigitalContent' + paramString, sdc);
      return this.studentService.saveStudentDigitalContent(sdc, schoolId)
    }

    deleteStudentDigitalContent(documentId: number): Observable<number> {
      let paramString: string = '';
      paramString += '?documentId=' + documentId;

      return this.http.post<number>(System.apiURL.Student + 'DeleteStudentDigitalContent' + paramString, null);
    }


}
